import React, { useEffect } from 'react';
import InventoryTableContainer from './InventoryTableContainer';
import { useTitle } from '../../hooks/useTitle';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  padding: 0;
  
  @media (max-width: 1200px) {
    padding: 0 8px;
  }
  
  @media (max-width: 768px) {
    padding: 0 4px;
  }
  
  @media (max-width: 480px) {
    padding: 0 2px;
  }
`;

const Inventory = () => {
    const { setTitle } = useTitle();
    useEffect(() => {
        setTitle('Inventory');
    }, [setTitle]);

    return (
        <Wrapper>
            <InventoryTableContainer />
        </Wrapper>
    );
};

export default Inventory; 